<div class="login-split">
  <!-- Brand panel -->
  <aside class="login-brand">
    <div class="login-brand-inner">
      <div class="login-lockup">
        <img src="assets/logo/zelustech-logo-only-cream-orange.svg" alt="" class="login-mark" />
        <span class="login-wordmark">ZelusHR</span>
      </div>

      <div class="login-brand-body">
        <h2 class="login-headline">Set a new password</h2>
      </div>

      <p class="login-trust">
        <lucide-icon [img]="icons.shieldCheck" [size]="16" />
        Your data is encrypted in transit and at rest
      </p>
    </div>
  </aside>

  <!-- Form panel -->
  <section class="login-panel">
    <div class="login-form-wrap">
      <header class="login-head">
        <h1 class="login-title">Set a new password</h1>
        <p class="login-subtitle">Your account needs a new password before you can continue.</p>
      </header>

      <form class="login-form" [formGroup]="form" (ngSubmit)="submit()">
        @if (errorTxt()) {
          <div class="login-error">
            <app-client-response-errors [errorTxt]="errorTxt()"></app-client-response-errors>
          </div>
        }

        <div class="zh-form-group">
          <label class="zh-form-label" for="cp-current">Current password</label>
          <div class="login-field login-field-reveal">
            <lucide-icon class="login-field-icon" [img]="icons.lock" [size]="18" />
            <input
              id="cp-current"
              [type]="showCurrent() ? 'text' : 'password'"
              formControlName="currentPassword"
              class="zh-input"
              autocomplete="current-password"
            />
            <button
              type="button"
              class="login-field-reveal-btn"
              [attr.aria-label]="showCurrent() ? 'Hide password' : 'Show password'"
              [attr.aria-pressed]="showCurrent()"
              (click)="showCurrent.set(!showCurrent())"
            >
              <lucide-icon [img]="showCurrent() ? icons.eyeOff : icons.eye" [size]="18" />
            </button>
          </div>
        </div>

        <div class="zh-form-group">
          <label class="zh-form-label" for="cp-new">New password</label>
          <div class="login-field login-field-reveal">
            <lucide-icon class="login-field-icon" [img]="icons.lock" [size]="18" />
            <input
              id="cp-new"
              [type]="showNew() ? 'text' : 'password'"
              formControlName="newPassword"
              class="zh-input"
              autocomplete="new-password"
              aria-describedby="cp-new-hints"
            />
            <button
              type="button"
              class="login-field-reveal-btn"
              [attr.aria-label]="showNew() ? 'Hide password' : 'Show password'"
              [attr.aria-pressed]="showNew()"
              (click)="showNew.set(!showNew())"
            >
              <lucide-icon [img]="showNew() ? icons.eyeOff : icons.eye" [size]="18" />
            </button>
          </div>
          <app-password-policy-hints
            id="cp-new-hints"
            [password]="newPassword()"
            [username]="username"
          />
        </div>

        <div class="zh-form-group">
          <label class="zh-form-label" for="cp-confirm">Confirm new password</label>
          <div class="login-field">
            <lucide-icon class="login-field-icon" [img]="icons.lock" [size]="18" />
            <input
              id="cp-confirm"
              [type]="showNew() ? 'text' : 'password'"
              formControlName="confirmPassword"
              class="zh-input"
              autocomplete="new-password"
              [class.is-invalid]="form.hasError('passwordMismatch')"
              [attr.aria-invalid]="form.hasError('passwordMismatch') ? true : null"
            />
          </div>
          @if (form.hasError('passwordMismatch')) {
            <div class="zh-validation-message error">Passwords do not match.</div>
          }
        </div>

        <!-- appZhLoading's host [attr.disabled] would clobber [disabled]; use its class directly. -->
        <button
          class="zh-btn zh-btn-primary login-submit-btn"
          type="submit"
          [disabled]="form.invalid || submitting()"
          [class.zh-btn-loading]="submitting()"
          [attr.aria-busy]="submitting()"
        >
          Update password
        </button>

        <p class="login-help">
          <button type="button" class="change-password-signout" (click)="authService.logout()">
            Sign out
          </button>
        </p>
      </form>
    </div>
  </section>
</div>
